export const compactNumber: any = (n: number) => Intl.NumberFormat('es-US', {
  notation: 'compact',
  maximumFractionDigits: 1,
}).format(n).replace(/\s/g, '').toLocaleLowerCase();
